/* globals isClient */
import React from 'react'
import {connect} from 'react-redux'
import Grail from 'elements/Grail'
import Disclaimer from '../disclaimer'
import Version from '../version'
import LoginBroker from './loginBroker'
import LoginClient from './loginClient'
import Registration from './registration'
import PasswordChange from './passwordChange'
import PasswordReset from './passwordReset'
import AccountConfirmation from './accountConfirmation'
import Sms from './sms'
import ga from 'react-ga'
import styles from './auth.scss'
import i18n from 'lib/i18n'
import {setAppModule} from 'state/actions'
import c from 'state/constants'

const _ = i18n('auth')

@connect(state => ({
	isLoggedIn: state.auth.isLoggedIn,
	authState: state.auth.authState,
	options: state.auth.options,
	isPhone: state.responsive.isPhone,
}))
export default class Auth extends React.Component {
	static propTypes = {
        dispatch: React.PropTypes.func.isRequired,
		authState: React.PropTypes.string.isRequired,
		isPhone: React.PropTypes.bool,
		isLoggedIn: React.PropTypes.bool.isRequired,
		options: React.PropTypes.any,
	}
	constructor(props) {
		super(props)

		this.state = {prevAuthState: 'start'}
	}
	componentDidMount() {
		this.sendAnalyticsData()
	}
	componentDidUpdate() {
		this.sendAnalyticsData()
	}
	sendAnalyticsData() {
		const {authState} = this.props
		let gaMsg

		if (authState) {
			gaMsg = authState
		} else {
			gaMsg = isClient ? "clientLogin" : "brokerLogin"
		}

		if (this.state.prevAuthState !== authState) {
			ga.pageview(gaMsg)
			this.setState({prevAuthState: authState})
		}
	}
	render() {
		const {authState, options, isPhone, dispatch} = this.props
		let component

		switch (authState) {
			case 'registration':
				component = <Registration/>
				break
			case 'sms':
				component = <Sms options={options}/>
				break
			case 'passwordReset':
				component = <PasswordReset options={options}/>
				break
			case 'passwordChange':
				component = <PasswordChange/>
				break
			case 'accountConfirmation':
				component = <AccountConfirmation/>
				break
			default:
				if (isClient) {
					component = <LoginClient/>
				} else {
					component = <LoginBroker/>
				}
				break
		}

		return (
			<Grail
				noScroll
				content={
					<div className={`${styles.authFormsOverlay} ${isPhone ? styles.mobile : ''}`}>
						{component}
					</div>
				}
				footer={
					<div>
						<div className={styles.privacy}>
							<a href={_('privacyStatementLink')} onClick={(e) => {
                                e.preventDefault()
                                // dispatch(changeAuthState(""))
                                // todo check if no language exist in local storage

                                let localLang = localStorage.getItem('clientLanguage')
                                if (localLang) {
                                    window.open("/privacy/"+localLang, '_blank', 'noopener,noreferrer')
                                } else {
                                    dispatch(setAppModule(c.PRIVACY))
                                }

                                return false
                            }}>
								{_('privacyStatement')}
							</a>

							<a href={isClient ? _('clientLink') : _('brokerLink')} className={styles.secondLink}>
								{_('cookiesLinkText')}
							</a>
						</div>
						<div className={styles.disclaimer}>
							<Disclaimer/>
							- <span className={styles.version}>
								<Version/>
							</span>
						</div>
					</div>
				}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./components/auth/auth.jsx